import axios from 'axios';

// Calls the website's own /api/* routes; they talk to tsum server-side.
const WebService = {
  async getStaffs({ limit, page }: { limit: number; page: number }) {
    const response = await axios.get('/api/staffs', { params: { limit, page } });
    return response.data;
  },
  async getBlogs({ limit, page }: { limit: number; page: number }) {
    const response = await axios.get('/api/blogs', { params: { limit, page } });
    return response.data;
  },
  async sendContactMessage(data: { name: string; email: string; phone: string; message: string }) {
    const response = await axios.post('/api/send-message', data).catch(() => null);
    return response?.data === true;
  },
  async sendRUOKMessage(data: {
    name: string;
    studentClass: string;
    message: string;
    type: string;
    email: string;
  }) {
    const response = await axios.post('/api/send-r-u-ok-message', data).catch(() => null);
    return response?.data === true;
  },
};

export default WebService;
